import React from "react";
import PropTypes from "prop-types";
import ChevronSVG from "assets/icons/chevron.inline.svg";

import Icon from "./Icon";

const Chevron = ({ ...rest }) => (
	<Icon
		name="chevron"
		alt="Chevron"
		{...rest}
	>
		<ChevronSVG />
	</Icon>
);

Chevron.propTypes = {
	fill: PropTypes.string,
};

Chevron.defaultProps = {
	fill: "blue",
};

export default Chevron;
